import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Job_event_bs$SolvuuApi0 from "./job_event_bs.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.list(Job_event_bs$SolvuuApi0.write_t, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.list(Job_event_bs$SolvuuApi0.read_t, param);
}

var read_event = Job_event_bs$SolvuuApi0.read_t;
var write_event = Job_event_bs$SolvuuApi0.write_t;
var read_t = read__1;
var write_t = write__1;
export { read_event, write_event, read_t, write_t };
/* Job_event_bs-SolvuuApi0 Not a pure module */